"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _responsiveProps = require("../../../internal/responsiveProps");
var _Wrapper = _interopRequireDefault(require("../../Wrapper"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const StyledGridItem = (0, _styledComponents.default)(props => /*#__PURE__*/_react.default.createElement(_Wrapper.default, _extends({
  omitProps: {
    responsiveKeys: ['span', 'startColumn', 'spanRows', 'startRow']
  }
}, props))).withConfig({
  displayName: "StyledGridItem",
  componentId: "sc-uns6s1-0"
})(["", " ", " ", " ", ""], props => (0, _responsiveProps.responsiveCssProps)({
  props,
  propName: 'span',
  output: span => `
          grid-column-end: span ${span};
          flex-basis: ${100 * span / 12}%;
        `
}), props => (0, _responsiveProps.responsiveCssProps)({
  props,
  propName: 'startColumn',
  cssProperty: 'grid-column-start'
}), props => (0, _responsiveProps.responsiveCssProps)({
  props,
  propName: 'spanRows',
  output: span => `grid-row-end: span ${span};`
}), props => (0, _responsiveProps.responsiveCssProps)({
  props,
  propName: 'startRow',
  cssProperty: 'grid-row-start'
}));

/**
## Usage

```jsx
import { Grid } from '@farewill/ui'

() => (
  <Grid>
    <Grid.Item />
  </Grid>
)
```

## Notes

`<Grid.Item>` extends from `<Wrapper>` so can use any of `<Wrapper>`'s styling functionality, notably its background, border, and padding props.

### Positioning

The `startColumn` and `startRow` props are used when you need finer grain control over positioning a `<Grid.Item>`, either when you want an item to not start on the top/left-hand side of the wrapper or when you want a multi-row or multi-column margin between items.

Note that this is not a value for the amount of rows/columns of gap to the top/left, but rather and absolute position from the top/left-hand side.

If you want a grid with a 5-column item, a 1-column gap, and another 5-column item, it would look like this:

```jsx
<Grid>
  <Grid.Item span={5} />
  <Grid.Item span={5} startColumn={7} />
</Grid>
```
 */
const GridItem = _ref => {
  let {
    children,
    span = 12,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(StyledGridItem, _extends({
    span: span
  }, props), children);
};
var _default = exports.default = GridItem;